import { render, staticRenderFns } from "./labelLang.vue?vue&type=template&id=81953bbc"
import script from "./labelLang.vue?vue&type=script&lang=js"
export * from "./labelLang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81953bbc')) {
      api.createRecord('81953bbc', component.options)
    } else {
      api.reload('81953bbc', component.options)
    }
    module.hot.accept("./labelLang.vue?vue&type=template&id=81953bbc", function () {
      api.rerender('81953bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labelLang.vue"
export default component.exports